import React from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import exploreCategoriesData from "../data/explore-categories.json";

const Categories = (props) => {
  return (
    <section className={`explore-categories-section ${props.greyBackground ? "" : "bg-white"}`}>
      <Container>
        {/* Header Block arranged inside exact same Row & Col structure as the Advantage Column 1 */}
        <Row>
          <Col lg="12" className="position-relative px-5">
            <div className="ps-lg-5">
              <h2 className="categories-title">Explore Categories</h2>
              <h3 className="categories-subtitle">Find trusted companies by technology and expertise.</h3>
            </div>
          </Col>
        </Row>

        {/* Content list structured inside same Col and nested ps-lg-5 to share the exact same axis natively */}
        <Row className="mt-4">
          <Col lg="12" className="position-relative px-5">
            <div className="ps-lg-5">
              <div className="categories-list-container mt-0">
                {/* Table headers */}
                <div className="categories-table-header">
                  <p className="categories-table-header-core mb-0">Core category</p>
                  <p className="categories-table-header-focus mb-0">Focus area</p>
                </div>
                
                <div className="categories-row-separator"></div>

                {/* Table rows */}
                {exploreCategoriesData.map((item, index) => {
                  const formattedIndex = String(index + 1).padStart(2, '0');
                  return (
                    <React.Fragment key={item.category.name}>
                      <div className="categories-row">
                        <span className="category-index">{formattedIndex}</span>
                        
                        <div className="category-core-col">
                          <Link href={item.category.url} className="category-link">
                            {item.category.name}
                            <span className="category-row-underline"></span>
                          </Link>
                        </div>
                        
                        <div className="category-focus-col">
                          {item.focusAreas.map((fa) => (
                            <Link key={fa.name} href={fa.url} className="focus-area-link">
                              {fa.name}
                            </Link>
                          ))}
                        </div>
                      </div>
                      <div className="categories-row-separator"></div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>

        {/* Browse All Services button styled elegantly */}
        <Row className="mt-4">
          <Col lg="12" className="position-relative px-5">
            <div className="ps-lg-5">
              <div className="browse-all-container mt-4">
                <Link href="/categories" className="browse-all-link">
                  Browse All Services
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="browse-all-icon"
                  >
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Categories;
